import { Capacitor } from "@capacitor/core";
import { useQuery } from "@tanstack/react-query";
import React from "react";
import {
  API,
  APIConfig,
  getNewAuthToken,
  isAppVersionOutdated,
  isUserLocked,
  LoginData,
} from "../../../../API";
import { CaregiverMobile } from "../../../../messages";
import Spinner from "../../../Generic/Spinner";

interface Props {
  apiConfig: APIConfig;
  refreshJWT: string;
  onVersionOutdated: () => void;
  onUserLocked: (phoneNumber: string) => void;
  onLogin: (params: { api: API; caregiver: CaregiverMobile; refreshJWT: string }) => void;
  onInvalidLogin: () => void;
  onUserNotRegistered: (loginData: LoginData) => void;
}

const PassthroughStage = (props: Props) => {
  useQuery({
    queryKey: [props.apiConfig.apiBaseUrl, "getNewAuthToken", props.refreshJWT, props.apiConfig],
    queryFn: () => getNewAuthToken(props.apiConfig, props.refreshJWT),
    onSuccess: (response) => {
      if (isAppVersionOutdated(response)) {
        return props.onVersionOutdated();
      }

      if (isUserLocked(response)) {
        return props.onUserLocked(props.refreshJWT);
      }

      if (response === null) {
        return props.onInvalidLogin();
      }

      const caregiver = response.payload.userLoginDetails.caregiver;

      if (caregiver === undefined) {
        return props.onUserNotRegistered(response);
      }

      const api = new API(
        props.apiConfig,
        {
          exp: response.payload.exp,
          accessJWT: response.tokens.accessJWT,
          refreshJWT: response.tokens.refreshJWT,
          caregiverId: caregiver.id,
        },
        Capacitor.getPlatform()
      );

      props.onLogin({
        api: api,
        caregiver: caregiver,
        refreshJWT: response.tokens.refreshJWT,
      });
    },
  });

  return <Spinner />;
};

export default PassthroughStage;
